export default {"src":"/_next/static/media/trong-rang-implant.4290245e.svg","height":100,"width":101,"blurWidth":0,"blurHeight":0};